"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActivatePlugin = void 0;
const PluginDetailModal_1 = __importDefault(require("@app/component/modals/plugin-detail/PluginDetailModal"));
const ui_1 = require("@app/component/ui");
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const use_modal_1 = require("../modal/use-modal");
const useActivatePlugin = (pluginName) => {
    const { addModal } = (0, use_modal_1.useModal)();
    const activatePluginFn = react_1.default.useCallback(() => addModal(PluginDetailModal_1.default, {
        plugin: {
            plugin: pluginName,
        },
        close: () => ({}),
    }), [pluginName, addModal]);
    const displayName = react_1.default.useMemo(() => `Activate${pluginName[0].toUpperCase()}${pluginName.slice(1)}Plugin`, [pluginName]);
    const ActivatePlugin = react_1.default.useCallback(() => {
        return (react_1.default.createElement(ui_1.Button, { key: displayName, style: 'BORDERLESS', onClick: activatePluginFn },
            (0, __1.t)('WS_SETTINGS_CARD_PLUGINS_SETTINGS_DETAIL_ENABLE'),
            ' ',
            (0, __1.t)(`PLUGIN_NAME.${pluginName}`),
            "\u00A0",
            react_1.default.createElement(ui_1.Icon, { size: 'small', color: 'primary', ico: 'arrow-right' })));
    }, [pluginName, activatePluginFn, displayName]);
    ActivatePlugin.displayName = displayName;
    return { ActivatePlugin, activatePluginFn };
};
exports.useActivatePlugin = useActivatePlugin;
